import React from "react";
import Phone from "../../assets/phone.svg";
import Mail from "../../assets/mail.svg";
import Terms from "../../assets/terms.png";

function termsofcondition() {
  return (
    <div className="container mx-auto p-5 md:px-8 lg:px-20">
      <div className="my-5 md:my-20">
        <h1 className="font-bold text-center font-newblack text-[40px] leading-[48px] mb-3">
          Terms & Condition
        </h1>
        <p className="font-newblack text-xl text-center font-bold">
          Last Updated: 25 July 2024
        </p>
        <div className=" flex justify-start items-center gap-10 pt-10 lg:flex">
          <img src={Terms} alt="fbt-b2b" />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 my-10 lg:grid-cols-3 md:gap-10 md:my-24">
        <div className="col-span-2 order-last lg:order-none">
          <p className="text-2xl font-bold font-newblack pt-2 md:pt-6 md:text-3xl">
            Terms & Condition
          </p>
          <p className="pt-2 text-slate-500 mb-5 font-medium text-md leading-[30px]">
            These Terms and Conditions ("Terms") govern your access to and use
            of the FBTB2B travel portal ("Portal") operated by FBT Adventures
            Travels LLC ("FBT Adventures," "we," "us," or "our"). By accessing
            or using the Portal, you agree to be bound by these Terms. If you do
            not agree with any part of these Terms, please do not use the
            Portal.
          </p>
          <p className="text-2xl font-bold font-newblack pt-2 md:pt-6 md:text-3xl">
            Terms & Condition Summary
          </p>
          <div id="pricing">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              1. Pricing
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              <span className="text-black font-bold underline">
                {" "}
                1.1 General Pricing
              </span>{" "}
              Policy Our policy guarantees affordable prices and the convenience
              of online reservations. Unless stated otherwise, the prices listed
              on our Portal may vary depending on the nature of the product and
              the selection of the booking format (e.g., per person, per room,
              etc.). Prices exclude tips for tour guides or drivers,
              passport/visa fees, travel insurance, meals, beverages,
              accommodations, room services, and laundry. Published rates may be
              subject to change without prior notice due to unforeseen
              circumstances such as excursion ticket or hotel rate increases, or
              transportation expenses.
            </p>
          </div>
          <div id="methodsofpayment">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              2. Methods of Payment
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              We accept most major credit cards, including Visa and MasterCard.
              Full payment is required via credit/debit card at the time of
              booking. You will be required to provide your card number to
              complete the transaction. The card details provided for a
              particular transaction will be used only for that transaction.
            </p>
          </div>
          <div id="confirmationofpayment">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              3. Confirmation of Payment
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              After the payment is successfully processed, our travel
              consultants will promptly send you a confirmation via email.
              Please keep a printed copy of the confirmation slip as proof of
              payment, which can be presented to the service provider to redeem
              your tour package. It is important to ensure that you have
              provided accurate information regarding your travel requirements
              during the booking process.
            </p>
          </div>
          <div id="cancellation">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              4. Cancellation & No-Show Policy
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              <span className="text-black underline font-bold">
                {" "}
                4.1 Cancellation{" "}
              </span>{" "}
              Each tour activity/attraction/hotel has its own specific
              cancellation policies.Before booking any activity with FBTB2B, it
              is essential for clients to carefully review the cancellation
              policy associated with that particular tour, hotel, ticket, visa,
              etc. Combo tours can be canceled; however, if an individual
              cancels any of the single tours within a combo, they will not be
              eligible to avail of the combo offer. In such cases, FBTB2B will
              consider the individual tour price of the non-canceled tour and
              refund the remaining amount. The fees for Tourist Visas are
              non-refundable once payment has been made on the FBTB2B portal.
              <br />
              <span className="text-black underline font-bold">
                {" "}
                4.2 No-Show{" "}
              </span>{" "}
              If you are unable to avail of the services booked as per your
              booking dates (e.g., hotel, scheduled tour, transfers, tickets,
              visa), no refunds, either partial or full, will be provided.
              Additionally, confirmed tours, airport transfers, and other
              travel-related services cannot be rescheduled.
              <br />
              <span className="text-black underline font-bold">
                4.3 Cancellation Procedures
              </span>
              Before proceeding with any cancellation, thoroughly review the
              cancellation policies specific to your hotel, tour package,
              transfers, tickets, or any other services. FBTB2B cannot assume
              responsibility for any uncancelled bookings on the FBTB2B Portal
              in accordance with the stated cancellation policy.
            </p>
          </div>
          <div id="itinerary">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              5. Itinerary Amendments
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              The routes and services included in your package may be subject to
              modifications due to local conditions, weather, airline schedules,
              and other factors beyond our control. In such cases, we will
              strive to offer suitable alternative options of similar value,
              based on availability. Any changes to the itinerary, if necessary,
              will be communicated to you prior to departure. FBTB2B retains the
              right to make minor amendments to the itinerary at any time
              without providing reimbursement. Additionally, in the event of
              force majeure circumstances such as floods or earthquakes, no
              reimbursements can be issued.
            </p>
          </div>
          <div id="checkinoutpolicy">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              6. Hotel Accommodation & Check-in/Check-out Policy
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              In the event that we are unable to secure accommodation at your
              preferred hotel, we will make every effort to offer you a suitable
              alternative of similar budget and standard. The check-in/check-out
              policy is primarily determined by the hotel you have selected.
              FBTB2B cannot be held accountable for any early or late
              check-in/check-out requests that are not accommodated by the hotel
              due to their busy schedule
            </p>
          </div>
          <div id="insurance">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              7. Travel Insurance
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              FBT Adventures assumes no responsibility for any damages resulting
              from accidents, illnesses, injuries, loss of personal belongings,
              or trip cancellations. We strongly recommend that travelers obtain
              a comprehensive travel insurance policy to mitigate unforeseen
              circumstances. Travel insurance can provide coverage and
              assistance in dealing with unexpected events.
            </p>
          </div>
          <div id="documents">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              8. Travel Documents
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              Every guest is personally responsible for ensuring they carry the
              necessary documents for their specific tour, including a valid
              passport or ID card. This is particularly important for guests
              traveling from a different country. No refunds can be provided in
              the event of loss or failure to possess these required documents.
              Passengers are advised to consult their respective country's
              consulate to obtain information on entry requirements prior to
              planning their visit. It is equally essential to inquire with your
              consulate regarding the latest visa and health requirements, as
              these can be subject to change without prior notice.
            </p>
          </div>
          <div id="restrictions">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              9. Website Usage Restrictions
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              All content on this website, including logos, images, tour package
              information, pricing details, and other relevant information, is
              the exclusive property of FBTB2B. By using this website, you agree
              not to misuse or exploit its content for any non-personal,
              commercial, or unlawful purposes.
            </p>
          </div>
          <div id="delivery&shipping">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              10. Delivery & Shipping Policy
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              <span className="text-black underline font-bold">
                10.1 Statement of Compliance
              </span>{" "}
              The website will NOT deal or provide any services or products to
              any OFAC (Office of Foreign Assets Control) sanctioned countries
              in accordance with the law of the UAE
            </p>
          </div>
          <div id="goveringlaw">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              11. Governing Law and Jurisdiction
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              Any purchase, dispute, or claim arising out of or in connection
              with this website shall be governed and construed in accordance
              with the laws of the UAE
            </p>
          </div>
          <div id="accesstermination">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              12. Access Termination and Taxes
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              <span className="text-black underline font-bold">
                12.1 Access Termination
              </span>{" "}
              FBT Adventures reserves the right, at its sole discretion, to
              terminate access to any or all FBTB2B websites, as well as its
              other sales channels and associated services, in whole or in part,
              at any time and without prior notice. This may occur for reasons
              including but not limited to general maintenance or for any other
              valid reason.
              <br />
              <span className="text-black underline font-bold">
                12.2 Taxes{" "}
              </span>{" "}
              All prices displayed are the final payable amount to us; however,
              in the event that government authorities, local governing bodies,
              or service providers apply any additional tax,fees, service
              charges, resort fee, or any other indirect charge without prior
              notification, or there is fluctuation in the rate of exchange
              (ROE) from booked currency against other currencies, these
              additional charges or supplement charges will be levied by us onto
              the reservation and will not be part of the reservation amount
              booked or paid. We will not be liable to pay these additional
              charges/taxes/resort fees/VAT/Revised ROE as we have limited
              control over such additional charges. The agent agrees and
              acknowledges that in the case of such impact, it shall be binding
              on the agent, and the booking which is to be proceeded or already
              booked but payment is not made, will be done on the new revised
              rate or else the agent can look for cancellation of said
              reservation as per the actual cancellation policy. <br />
              <br />
              By using the FBTB2B travel portal, you acknowledge that you have
              read, understood, and agree to these Terms and Conditions.
            </p>
          </div>
          <div id="contactus" className="w-full md:w-3/4">
            <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
              12. Contact us
            </p>
            <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
              <span className="text-black font-bold">
                FBT Adventures Travels LLC
              </span>
              <br />
              <span className="text-sm ">
                Office No 400-70, 4th Floor Fahidi Height Office Tower, Sharaf
                DG Metro Station gate No. 4 - Bur Dubai – Dubai, United Arab
                Emirates
              </span>
              <span className="flex gap-2 my-1 text-black">
                <img src={Mail} alt="Journeyx" />
                <a href="mailto:care@fbt.ae" className="hover">
                  care@fbt.ae
                </a>
              </span>
              <span className="flex gap-2 mb-1 text-black">
                <img src={Phone} alt="Journeyx" />
                <a href="tel:+971-43271179" className="hover">
                  +971-43271179
                </a>
              </span>
            </p>
          </div>
        </div>
        <div>
          <p className="text-2xl font-bold font-newblack py-2 md:pt-6 ">
            Table of Content:
          </p>
          <ul className="list-disc text-black ml-5">
            <a href="#pricing">
              <li className="underline mb-2 hover">1. Pricing</li>
            </a>
            <a href="#methodsofpayment">
              <li className="underline mb-2 hover"> 2. Methods of Payment</li>
            </a>
            <a href="#confirmationofpayment">
              <li className="underline mb-2 hover">
                3. Confirmation of Payment
              </li>
            </a>
            <a href="#cancellation">
              <li className="underline mb-2 hover">
                4. Cancellation & No-Show Policy
              </li>
            </a>
            <a href="#itinerary">
              <li className="underline mb-2 hover">5. Itinerary Amendments</li>
            </a>
            <a href="#checkinoutpolicy">
              <li className="underline mb-2 hover">
                6. Hotel Accommodation & Check-in/Check-out Policy
              </li>
            </a>
            <a href="#insurance">
              <li className="underline mb-2 hover">7. Travel Insurance</li>
            </a>
            <a href="#documents">
              <li className="underline mb-2 hover">8. Travel Documents</li>
            </a>
            <a href="#restrictions">
              <li className="underline mb-2 hover">
                9. Website Usage Restrictions
              </li>
            </a>

            <a href="#delivery&shipping">
              <li className="underline mb-2 hover">
                10. Delivery & Shipping Policy
              </li>
            </a>
            <a href="#goveringlaw">
              <li className="underline mb-2 hover">
                11. Governing Law and Jurisdiction
              </li>
            </a>
            <a href="#accesstermination">
              <li className="underline mb-2 hover">
                12. Access Termination and Taxes
              </li>
            </a>
            <a href="#contactus">
              <li className="underline mb-2 hover">13. Contact Us</li>
            </a>
          </ul>
          <hr className="mt-10 h-0.5" />
        </div>
      </div>
    </div>
  );
}

export default termsofcondition;
